import { AppShell, Box, Center, useUpdateBodyBackground } from '@tf/ui';
import type React from 'react';
import { Outlet } from 'react-router-dom';

import { FormControlRefsProvider } from '@/core/providers';

import { Affix } from './Affix';
import { Footer } from './Footer';
import { MenuProvider } from './MenuProvider';
import { Sidebar } from './Sidebar';

export const AppLayout: React.FC = () => {
	useUpdateBodyBackground('#F9FAFB');

	return (
		<MenuProvider>
			<FormControlRefsProvider>
				<AppShell layout="alt">
					<Sidebar />
					<AppShell.Main maw="1900px" mih="calc(100dvh - 70px)" pl="300px">
						<Center p="1rem" sx={{ '& > *': { flex: 1 } }}>
							<Outlet />
						</Center>
					</AppShell.Main>
					<Affix />
					<Box ml="300px">
						<Footer withBorder style={{ maxWidth: '1600px' }} />
					</Box>
				</AppShell>
			</FormControlRefsProvider>
		</MenuProvider>
	);
};
